import type { FC } from 'react'
import type { CroppedImage } from '../../types/croppedImage'

export interface CmsImageProps {
    image: CroppedImage | undefined
    eager?: boolean
    fallbackSrc?: string
    className?: string
    containerClass?: string
}

const desktopWithFallback = (image: CroppedImage) => image.desktop || image.tablet || image.mobile || image.portrait

// eslint-disable-next-line complexity -- not complex at all
export const CmsImage: FC<CmsImageProps> = props => {
    const { image, eager = false, fallbackSrc } = props

    if (!image && !fallbackSrc) return null
    if (!image) return <img className={props.className} src={fallbackSrc} loading={eager ? 'eager' : 'lazy'} />

    return (
        <picture className={props.containerClass}>
            {/* Set max-width as 1px less than media query break point, as the scss media query util counts resolutions
                as inclusive of their starting resolution, but exclusive of their upper limits. */}
            {image?.portrait && <source media="(max-width:479px)" srcSet={image.portrait} />}
            {image?.mobile && <source media="(max-width:767px)" srcSet={image.mobile} />}
            {image?.tablet && <source media="(max-width:1023px)" srcSet={image.tablet} />}

            <img
                className={props.className}
                src={desktopWithFallback(image)}
                alt={image.alt}
                loading={eager ? 'eager' : 'lazy'}
            />
        </picture>
    )
}
